import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ButtonModule, CheckboxModule, InputModule, RadioModule, SelectModule, TextareaModule } from '@sag-ui';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AttachmentsInputComponent } from '../../../../shared/components/attachments-input/attachments-input.component';
import { filter, tap } from 'rxjs';
import { EskerDomesticForm, EskerDomesticFormGroup } from '../../../models/cod-create.model';
import { Store } from '@ngxs/store';
import { AddCurrentCodLine, AddErrorMessage, RemoveErrorMessage } from '../../../state/cod.action';
import { WorkflowError } from '../../../../shared/enums/workflow-error';
import { ManagerSelectComponent } from '../../../../shared/components/manager-select/manager-select.component';

@Component({
    selector: 'app-cod-esker-discrepancy-domestic-step',
    templateUrl: './esker-discrepancy-domestic.component.html',
    imports: [
        CommonModule,
        SelectModule,
        InputModule,
        FormsModule,
        ReactiveFormsModule,
        RadioModule,
        CheckboxModule,
        ButtonModule,
        TextareaModule,
        AttachmentsInputComponent,
        ManagerSelectComponent
    ],
    standalone: true
})
export class CodEskerDiscrepancyDomesticStepComponent implements OnInit {
    @Input() eskerDiscrepancyDomesticForm: FormGroup<EskerDomesticFormGroup> | undefined;

    private relatedCallTrackingNumberTouched = false;

    constructor(private store: Store) { }

    ngOnInit(): void {
        this.initFinancialAdjustmentChangesListener();
        this.initCallTagTrackingNumberTouchedListener();
        this.initRelatedDocumentsListener();
    }

    public isDefined(control: keyof EskerDomesticForm): boolean {
        return this.eskerDiscrepancyDomesticForm?.controls[control].value !== null;
    }

    public isTrue(control: keyof EskerDomesticForm): boolean {
        return this.eskerDiscrepancyDomesticForm?.controls[control].value === true;
    }

    public isFalse(control: keyof EskerDomesticForm): boolean {
        return this.eskerDiscrepancyDomesticForm?.controls[control].value === false;
    }

    public handleConfirm() {
        if (this.eskerDiscrepancyDomesticForm?.valid) {
            this.store.dispatch(new AddCurrentCodLine());
        }
    }

    public isValid(): boolean {
        return this.eskerDiscrepancyDomesticForm?.valid ?? false;
    }

    private initFinancialAdjustmentChangesListener(): void {
        this.eskerDiscrepancyDomesticForm?.controls.financialAdjustment.valueChanges
            .pipe(
                filter(value => value === false),
                tap(() => {
                    this.eskerDiscrepancyDomesticForm?.controls.adjustmentAmount.setValue(0);
                    this.eskerDiscrepancyDomesticForm?.controls.filedWithin30Days.setValue(null);
                    this.eskerDiscrepancyDomesticForm?.controls.managerApprovedRequest.setValue(null);
                }))
            .subscribe();
    }

    private initCallTagTrackingNumberTouchedListener(): void {
        this.eskerDiscrepancyDomesticForm?.controls.callTagTrackingNumber.valueChanges
            .pipe(
                filter(() => !this.relatedCallTrackingNumberTouched),
                tap(() => {
                    this.store.dispatch(new AddErrorMessage(WorkflowError.UPLOAD_PROOF));

                    this.relatedCallTrackingNumberTouched = true;
                })
            )
            .subscribe();
    }

    private initRelatedDocumentsListener(): void {
        this.eskerDiscrepancyDomesticForm?.controls.relatedDocuments.valueChanges
            .pipe(
                filter(value => !!value && value.length > 0),
                tap(() => this.store.dispatch(new RemoveErrorMessage(WorkflowError.UPLOAD_PROOF)))
            )
            .subscribe();
    }
}
